app.controller(
    'WalkController', ['$scope', '$state', WalkController]
);


function WalkController($scope, $state) {

    $scope.edit = {
        etapes: {}
    };

    $scope.client = {
        name: 'Art et architecture',
        sousTitre: 'Les passages couverts',
        titreDesc: 'Galerie Vivienne',
        sousTitreDesc: 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non' + ' nulli velariis',
        resumeDesc: 'résumé',
        txtDesc: 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non nulli velariis umbraculorum theatralium latent, quae Campanam imitatus lasciviam Catulus in aedilitate sua suspendit omnium primus; aut pugnaciter aleis certant turpi sono fragosis naribus introrsum reducto spiritu concrepantes; aut quod est studiorum omnium maximum ab ortu lucis ad vesperam sole fatiscunt vel pluviis, per minutias aurigarum equorumque praecipua vel delicta scrutantes.',

        qualifications: [
            {
                name: 'Qualification 01',
                checked: false
            },
            {
                name: 'Qualification 02',
                checked: false
            },
            {
                name: 'Qualification 03',
                checked: false
            },
            {
                name: 'Qualification 04',
                checked: false
            },
            {
                name: 'Qualification 05',
                checked: false
            },
            {
                name: 'Qualification 06',
                checked: false
            },
            {
                name: 'Qualification 07',
                checked: false
            },
            {
                name: 'Qualification 08',
                checked: false
            },
            {
                name: 'Qualification 09',
                checked: false
            },
            {
                name: 'Qualification 10',
                checked: false
            },
            {
                name: 'Qualification 11',
                checked: false
            },
            {
                name: 'Qualification 12',
                checked: false
            },


        ],
        status: [
            {
                name: 'Statut 01',
                checked: false
            },
            {
                name: 'Statut 02',
                checked: false
            },
            {
                name: 'Statut 03',
                checked: false
            },
            {
                name: 'Statut 04',
                checked: false
            },
            {
                name: 'Statut 05',
                checked: false
            },
            {
                name: 'Statut 06',
                checked: false
            },
            {
                name: 'Statut 07',
                checked: false
            },
            {
                name: 'Statut 08',
                checked: false
            },
            {
                name: 'Statut 09',
                checked: false
            },
            {
                name: 'Statut 10',
                checked: false
            },
            {
                name: 'Statut 11',
                checked: false
            },
            {
                name: 'Statut 12',
                checked: false
            },


        ],
        auteurs: [
            {
                name: 'Auteur 01',
                checked: false
            },
            {
                name: 'Auteur 02',
                checked: false
            },
            {
                name: 'Auteur 03',
                checked: false
            },
            {
                name: 'Auteur 04',
                checked: false
            },
            {
                name: 'Auteur 05',
                checked: false
            },
            {
                name: 'Auteur 06',
                checked: false
            },
            {
                name: 'Auteur 07',
                checked: false
            },
            {
                name: 'Auteur 08',
                checked: false
            },
            {
                name: 'Auteur 09',
                checked: false
            },
            {
                name: 'Auteur 10',
                checked: false
            },
            {
                name: 'Auteur 11',
                checked: false
            },
            {
                name: 'Auteur 12',
                checked: false
            },


        ],
        traducteurs: [
            {
                name: 'Traducteur 01',
                checked: false
            },
            {
                name: 'Traducteur 02',
                checked: false
            },
            {
                name: 'Traducteur 03',
                checked: false
            },
            {
                name: 'Traducteur 04',
                checked: false
            },
            {
                name: 'Traducteur 05',
                checked: false
            },
            {
                name: 'Traducteur 06',
                checked: false
            },
            {
                name: 'Traducteur 07',
                checked: false
            },
            {
                name: 'Traducteur 08',
                checked: false
            },
            {
                name: 'Traducteur 09',
                checked: false
            },
            {
                name: 'Traducteur 10',
                checked: false
            },
            {
                name: 'Traducteur 11',
                checked: false
            },
            {
                name: 'Traducteur 12',
                checked: false
            },


        ],
        correcteurs: [
            {
                name: 'Correcteur 01',
                checked: false
            },
            {
                name: 'Correcteur 02',
                checked: false
            },
            {
                name: 'Correcteur 03',
                checked: false
            },
            {
                name: 'Correcteur 04',
                checked: false
            },
            {
                name: 'Correcteur 05',
                checked: false
            },
            {
                name: 'Correcteur 06',
                checked: false
            },
            {
                name: 'Correcteur 07',
                checked: false
            },
            {
                name: 'Correcteur 08',
                checked: false
            },
            {
                name: 'Correcteur 09',
                checked: false
            },
            {
                name: 'Correcteur 10',
                checked: false
            },
            {
                name: 'Correcteur 11',
                checked: false
            },
            {
                name: 'Correcteur 12',
                checked: false
            },


        ],
        secretairesDeRedaction: [
            {
                name: 'Secretaire de rédaction 01',
                checked: false
            },
            {
                name: 'Secretaire de rédaction 02',
                checked: false
            },
            {
                name: 'Secretaire de rédaction 03',
                checked: false
            },
            {
                name: 'Secretaire de rédaction 04',
                checked: false
            },
            {
                name: 'Secretaire de rédaction 05',
                checked: false
            },
            {
                name: 'Rédactrice 06',
                checked: false
            },
            {
                name: 'Rédactrice 07',
                checked: false
            },
            {
                name: 'Rédactrice 08',
                checked: false
            },
            {
                name: 'Rédactrice 09',
                checked: false
            },
            {
                name: 'Rédactrice 10',
                checked: false
            },
            {
                name: 'Rédactrice 11',
                checked: false
            },
            {
                name: 'Rédactrice 12',
                checked: false
            },


        ],
        langues: [
            {
                name: 'Français',
                checked: false
            },
            {
                name: 'Anglais',
                checked: false
            },
            {
                name: 'Japonais',
                checked: false
            },
            {
                name: 'Espagnole',
                checked: false
            },
            {
                name: 'Italien',
                checked: false
            },
            {
                name: 'Allemand',
                checked: false
            },
            {
                name: 'Hollandais',
                checked: false
            },
            {
                name: 'Corréen',
                checked: false
            },
            {
                name: 'Chinois',
                checked: false
            },
            {
                name: 'Russe',
                checked: false
            },
            {
                name: 'Suédois',
                checked: false
            },
            {
                name: 'Grec',
                checked: false
            },


        ],

        clients: [
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: false
            },
            {
                name: 'LV Print',
                checked: false
            },
            {
                name: 'LV App',
                checked: false
            },
            {
                name: 'LV Print',
                checked: false
            },
            {
                name: 'LV App',
                checked: false
            },
        ],
        diffuseurs: [
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: false
            },
            {
                name: 'LV Print',
                checked: false
            },
            {
                name: 'LV App',
                checked: false
            },
            {
                name: 'LV Print',
                checked: false
            },
            {
                name: 'LV App',
                checked: false
            },
        ],
        classifications: [
            {
                name: 'Art moderne',
                checked: true
            },
            {
                name: 'Haute époque',
                checked: true
            },
            {
                name: 'Art moderne',
                checked: true
            },
            {
                name: 'Haute époque',
                checked: true
            },
            {
                name: 'Art moderne',
                checked: false
            },
            {
                name: 'Haute époque',
                checked: false
            },


        ]
    };

    $scope.walks = [
        {
            title: 'Nature',
            subtitle: 'La villa Borghèse',
            duration: '3 heures',
            city: 'Rome',
            position: '1'
        },
        {
            title: 'Urbain',
            subtitle: 'La villa Paris',
            duration: '5 heures',
            city: 'Paris',
            position: '2'
        },
        {
            title: 'Futuriste',
            subtitle: 'Shibuya Tour',
            duration: '5 heures',
            city: 'Tokyo',
            position: '3'
        },
    ];

    $scope.newClient = angular.copy($scope.client);

    $scope.contentTranslate = null;

    $scope.planning = {
        etapes: [
            {
                'nameEtape': 'Étape 1',
                'schedule': 'Nom de l\'étape',
                'heureH': '8',
                'heureM': '00',
                'dureeH': '1 ',
                'dureeM': '00',
                'titre': 'Galerie Valois',
                'sousTitre': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non' + ' nulli velariis',
                'description': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non nulli velariis umbraculorum theatralium latent, quae Campanam imitatus lasciviam Catulus in aedilitate sua suspendit omnium primus; aut pugnaciter aleis certant turpi sono fragosis naribus introrsum reducto spiritu concrepantes; aut quod est studiorum omnium maximum ab ortu lucis ad vesperam sole fatiscunt vel pluviis, per minutias aurigarum equorumque praecipua vel delicta scrutantes.'
            },
            {
                'nameEtape': 'Étape 2',
                'schedule': '',
                'heureH': '9',
                'heureM': '00',
                'dureeH': '1 ',
                'dureeM': '00',
                'titre': 'Passage des deux-pavillons',
                'sousTitre': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non' + ' nulli velariis',
                'description': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non nulli velariis umbraculorum theatralium latent, quae Campanam imitatus lasciviam Catulus in aedilitate sua suspendit omnium primus; aut pugnaciter aleis certant turpi sono fragosis naribus introrsum reducto spiritu concrepantes; aut quod est studiorum omnium maximum ab ortu lucis ad vesperam sole fatiscunt vel pluviis, per minutias aurigarum equorumque praecipua vel delicta scrutantes.'
            },
            {
                'nameEtape': 'Étape 3',
                'schedule': '',
                'heureH': '10',
                'heureM': '00',
                'dureeH': '1 ',
                'dureeM': '00',
                'titre': 'Galerie Vivienne',
                'sousTitre': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non' + ' nulli velariis',
                'description': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non nulli velariis umbraculorum theatralium latent, quae Campanam imitatus lasciviam Catulus in aedilitate sua suspendit omnium primus; aut pugnaciter aleis certant turpi sono fragosis naribus introrsum reducto spiritu concrepantes; aut quod est studiorum omnium maximum ab ortu lucis ad vesperam sole fatiscunt vel pluviis, per minutias aurigarum equorumque praecipua vel delicta scrutantes.'
            },
            {
                'nameEtape': 'Étape 4',
                'schedule': '',
                'heureH': '11',
                'heureM': '00',
                'dureeH': '1 ',
                'dureeM': '00',
                'titre': 'Passage Jouffroy',
                'sousTitre': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non' + ' nulli velariis',
                'description': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non nulli velariis umbraculorum theatralium latent, quae Campanam imitatus lasciviam Catulus in aedilitate sua suspendit omnium primus; aut pugnaciter aleis certant turpi sono fragosis naribus introrsum reducto spiritu concrepantes; aut quod est studiorum omnium maximum ab ortu lucis ad vesperam sole fatiscunt vel pluviis, per minutias aurigarum equorumque praecipua vel delicta scrutantes.'
            },
            {
                'nameEtape': 'Étape 5',
                'schedule': '',
                'heureH': '12',
                'heureM': '00',
                'dureeH': '1 ',
                'dureeM': '00',
                'titre': 'Passage Verdeau',
                'sousTitre': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non' + ' nulli velariis',
                'description': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non nulli velariis umbraculorum theatralium latent, quae Campanam imitatus lasciviam Catulus in aedilitate sua suspendit omnium primus; aut pugnaciter aleis certant turpi sono fragosis naribus introrsum reducto spiritu concrepantes; aut quod est studiorum omnium maximum ab ortu lucis ad vesperam sole fatiscunt vel pluviis, per minutias aurigarum equorumque praecipua vel delicta scrutantes.'
            }
        ],
        diffuseurs: [
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked: false
            },
            {
                name: 'LV Print',
                checked: false
            },
            {
                name: 'LV App',
                checked: false
            },
            {
                name: 'LV Print',
                checked: false
            },
            {
                name: 'LV App',
                checked: false
            },
        ]
    };

    $scope.newDescriptifClient = function () {

        for (var i = 0; i < $scope.client.diffuseurs.length; i++) {
            $scope.client.diffuseurs[i].checked = false;
        }
        for (var i = 0; i < $scope.client.clients.length; i++) {
            $scope.client.clients[i]['checked'] = false;
        }
        for (var i = 0; i < $scope.planning.diffuseurs.length; i++) {
            $scope.planning.diffuseurs[i]['checked'] = false;
        }
    };

    $scope.addStep = function () {
        $scope.planning.etapes.push({
            nameEtape: null,
            schedule: null,
            heureH: null,
            heureM: null,
            dureeH: null,
            dureeM: null,
            titre: null,
            sousTitre: null,
            description: null,
            openDropdown: true,
            edition: true
        });
    };

    $scope.slider = {
        min: 1,
        max: 24,
        options: {
            floor: 0,
            ceil: 23,
            translate: function (value) {
                return value + 'h';
            },
            hideLimitLabels: true
        }
    };

    $scope.toggleAll = function () {
        angular.forEach($scope.walks, function (itm) {
            itm.selected = $scope.isAllSelected;
        });
    }

    $scope.optionToggled = function () {
        $scope.isAllSelected = $scope.walks.every(function (itm) {
            return itm.selected;
        });
    }

    /**
     * Liste menu création
     */
    $scope.links = [
        {
            name: 'app.creationItinary.name',
            label: 'Nom & Adresse',
            state: null // edit-valid, valid
        },
        {
            name: 'app.creationItinary.contacts',
            label: 'Contacts & Droits'
        },
        {
            name: 'app.creationItinary.infos',
            label: 'Infos complémentaires'
        },
        {
            name: 'app.creationItinary.classification',
            label: 'Classification'
        },
        {
            name: 'app.creationItinary.descriptif',
            label: 'Descriptif'
        },
        {
            name: 'app.creationItinary.steps',
            label: 'Étapes'
        },
        {
            name: 'app.creationItinary.events',
            label: 'Lieux et Événements'
        },
        {
            name: 'app.creationItinary.visuel',
            label: 'Visuel'
        },
        {
            name: 'app.creationItinary.sources',
            label: 'Sources & Commentaires'
        }
    ];

    $scope.SelecAll = function (delectAll) {
        for (var i = 0; i < $scope.item.description[0].clients.length; i++) {
            $scope.item.description[0].clients3[i].checked = delectAll;
        }
    };
    $scope.classificationBox = false;

    $scope.showOptionsBox = function (item) {
        $scope.classificationBox = true;
        $scope.itemSelected = item;
    }
    $scope.item = {
        name : 'Musée du Louvre 24',
        sousTitre : 'Nom vernaculaire',
        description : [
            {
                titreDesc : 'Institution, Beaux-Arts 6',
                sousTitreDesc : 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non' +
                ' nulli velariis',
                resumeDesc : 'résumé',
                txtDesc : 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non' +
                ' nulli velariis umbraculorum theatralium latent, quae Campanam imitatus lasciviam Catulus in aedilitate sua suspendit omnium primus; aut pugnaciter aleis certant turpi sono fragosis naribus introrsum reducto spiritu concrepantes; aut quod est studiorum omnium maximum ab ortu lucis ad vesperam sole fatiscunt vel pluviis, per minutias aurigarum equorumque praecipua vel delicta scrutantes.',
                clients : [
                    {
                        name : 'LV Print',
                        checked : true
                    },
                    {
                        name : 'LV App',
                        checked : true
                    },
                    {
                        name : 'LV Print',
                        checked : true
                    },
                    {
                        name : 'LV App',
                        checked : true
                    },
                    {
                        name : 'LV Print',
                        checked : true
                    },
                    {
                        name : 'LV App',
                        checked : true
                    },
                    {
                        name : 'LV Print',
                        checked : true
                    },
                    {
                        name : 'LV App',
                        checked : false
                    },
                    {
                        name : 'LV Print',
                        checked : false
                    },
                    {
                        name : 'LV App',
                        checked : false
                    },
                    {
                        name : 'LV Print',
                        checked : false
                    },
                    {
                        name : 'LV App',
                        checked : false
                    },
                ],
                clients2 : [
                    {
                        name : 'LV Print',
                        checked : true
                    },
                    {
                        name : 'LV App',
                        checked : true
                    },
                    {
                        name : 'LV Print',
                        checked : true
                    },
                    {
                        name : 'LV App',
                        checked : true
                    },
                    {
                        name : 'LV Print',
                        checked : true
                    },
                    {
                        name : 'LV App',
                        checked : true
                    },
                    {
                        name : 'LV Print',
                        checked : true
                    },
                    {
                        name : 'LV App',
                        checked : false
                    },
                    {
                        name : 'LV Print',
                        checked : false
                    },
                    {
                        name : 'LV App',
                        checked : false
                    },
                    {
                        name : 'LV Print',
                        checked : false
                    },
                    {
                        name : 'LV App',
                        checked : false
                    },
                ],
                clients3 : [
                    {
                        ID : '12',
                        detenteur : 'John',
                        fermeture : '12/12/12',
                        reserve : 'oui',
                        url : 'entite.com',
                        checked : false
                    },
                    {
                        ID : '12',
                        detenteur : 'John',
                        fermeture : '12/12/12',
                        reserve : 'oui',
                        url : 'entite.com',
                        checked : false
                    },
                    {
                        ID : '12',
                        detenteur : 'John',
                        fermeture : '12/12/12',
                        reserve : 'oui',
                        url : 'entite.com',
                        checked : false
                    },
                    {
                        ID : '12',
                        detenteur : 'John',
                        fermeture : '12/12/12',
                        reserve : 'oui',
                        url : 'entite.com',
                        checked : false
                    },
                    {
                        ID : '12',
                        detenteur : 'John',
                        fermeture : '12/12/12',
                        reserve : 'oui',
                        url : 'entite.com',
                        checked : false
                    }
                ],
                classifications : [
                    {
                        name : 'Art moderne',
                        checked : true
                    },
                    {
                        name : 'Haute époque',
                        checked : true
                    },
                    {
                        name : 'Art moderne',
                        checked : true
                    },
                    {
                        name : 'Haute époque',
                        checked : true
                    },
                    {
                        name : 'Art moderne',
                        checked : false
                    },
                    {
                        name : 'Haute époque',
                        checked : false
                    },


                ],

                qualifications : [
                    {
                        name : 'Qualification 01',
                        checked : false
                    },
                    {
                        name : 'Qualification 02',
                        checked : false
                    },
                    {
                        name : 'Qualification 03',
                        checked : false
                    },
                    {
                        name : 'Qualification 04',
                        checked : false
                    },
                    {
                        name : 'Qualification 05',
                        checked : false
                    },
                    {
                        name : 'Qualification 06',
                        checked : false
                    },
                    {
                        name : 'Qualification 07',
                        checked : false
                    },
                    {
                        name : 'Qualification 08',
                        checked : false
                    },
                    {
                        name : 'Qualification 09',
                        checked : false
                    },
                    {
                        name : 'Qualification 10',
                        checked : false
                    },
                    {
                        name : 'Qualification 11',
                        checked : false
                    },
                    {
                        name : 'Qualification 12',
                        checked : false
                    },


                ],
                status : [
                    {
                        name : 'Statut 01',
                        checked : false
                    },
                    {
                        name : 'Statut 02',
                        checked : false
                    },
                    {
                        name : 'Statut 03',
                        checked : false
                    },
                    {
                        name : 'Statut 04',
                        checked : false
                    },
                    {
                        name : 'Statut 05',
                        checked : false
                    },
                    {
                        name : 'Statut 06',
                        checked : false
                    },
                    {
                        name : 'Statut 07',
                        checked : false
                    },
                    {
                        name : 'Statut 08',
                        checked : false
                    },
                    {
                        name : 'Statut 09',
                        checked : false
                    },
                    {
                        name : 'Statut 10',
                        checked : false
                    },
                    {
                        name : 'Statut 11',
                        checked : false
                    },
                    {
                        name : 'Statut 12',
                        checked : false
                    },


                ],
                diffuseurs : [
                    {
                        name : 'Diffuseur 01',
                        checked : false
                    },
                    {
                        name : 'Diffuseur 02',
                        checked : false
                    },
                    {
                        name : 'Diffuseur 03',
                        checked : false
                    },
                    {
                        name : 'Diffuseur 04',
                        checked : false
                    },
                    {
                        name : 'Diffuseur 05',
                        checked : false
                    },
                    {
                        name : 'Diffuseur 06',
                        checked : false
                    },
                    {
                        name : 'Diffuseur 07',
                        checked : false
                    },
                    {
                        name : 'Diffuseur 08',
                        checked : false
                    },
                    {
                        name : 'Diffuseur 09',
                        checked : false
                    },
                    {
                        name : 'Diffuseur 10',
                        checked : false
                    },
                    {
                        name : 'Diffuseur 11',
                        checked : false
                    },
                    {
                        name : 'Diffuseur 12',
                        checked : false
                    },


                ],
                auteurs : [
                    {
                        name : 'Auteur 01',
                        checked : false
                    },
                    {
                        name : 'Auteur 02',
                        checked : false
                    },
                    {
                        name : 'Auteur 03',
                        checked : false
                    },
                    {
                        name : 'Auteur 04',
                        checked : false
                    },
                    {
                        name : 'Auteur 05',
                        checked : false
                    },
                    {
                        name : 'Auteur 06',
                        checked : false
                    },
                    {
                        name : 'Auteur 07',
                        checked : false
                    },
                    {
                        name : 'Auteur 08',
                        checked : false
                    },
                    {
                        name : 'Auteur 09',
                        checked : false
                    },
                    {
                        name : 'Auteur 10',
                        checked : false
                    },
                    {
                        name : 'Auteur 11',
                        checked : false
                    },
                    {
                        name : 'Auteur 12',
                        checked : false
                    },


                ],
                traducteurs : [
                    {
                        name : 'Traducteur 01',
                        checked : false
                    },
                    {
                        name : 'Traducteur 02',
                        checked : false
                    },
                    {
                        name : 'Traducteur 03',
                        checked : false
                    },
                    {
                        name : 'Traducteur 04',
                        checked : false
                    },
                    {
                        name : 'Traducteur 05',
                        checked : false
                    },
                    {
                        name : 'Traducteur 06',
                        checked : false
                    },
                    {
                        name : 'Traducteur 07',
                        checked : false
                    },
                    {
                        name : 'Traducteur 08',
                        checked : false
                    },
                    {
                        name : 'Traducteur 09',
                        checked : false
                    },
                    {
                        name : 'Traducteur 10',
                        checked : false
                    },
                    {
                        name : 'Traducteur 11',
                        checked : false
                    },
                    {
                        name : 'Traducteur 12',
                        checked : false
                    },


                ],
                correcteurs : [
                    {
                        name : 'Correcteur 01',
                        checked : false
                    },
                    {
                        name : 'Correcteur 02',
                        checked : false
                    },
                    {
                        name : 'Correcteur 03',
                        checked : false
                    },
                    {
                        name : 'Correcteur 04',
                        checked : false
                    },
                    {
                        name : 'Correcteur 05',
                        checked : false
                    },
                    {
                        name : 'Correcteur 06',
                        checked : false
                    },
                    {
                        name : 'Correcteur 07',
                        checked : false
                    },
                    {
                        name : 'Correcteur 08',
                        checked : false
                    },
                    {
                        name : 'Correcteur 09',
                        checked : false
                    },
                    {
                        name : 'Correcteur 10',
                        checked : false
                    },
                    {
                        name : 'Correcteur 11',
                        checked : false
                    },
                    {
                        name : 'Correcteur 12',
                        checked : false
                    },


                ],
                secretairesDeRedaction : [
                    {
                        name : 'Secretaire de rédaction 01',
                        checked : false
                    },
                    {
                        name : 'Secretaire de rédaction 02',
                        checked : false
                    },
                    {
                        name : 'Secretaire de rédaction 03',
                        checked : false
                    },
                    {
                        name : 'Secretaire de rédaction 04',
                        checked : false
                    },
                    {
                        name : 'Secretaire de rédaction 05',
                        checked : false
                    },
                    {
                        name : 'Rédactrice 06',
                        checked : false
                    },
                    {
                        name : 'Rédactrice 07',
                        checked : false
                    },
                    {
                        name : 'Rédactrice 08',
                        checked : false
                    },
                    {
                        name : 'Rédactrice 09',
                        checked : false
                    },
                    {
                        name : 'Rédactrice 10',
                        checked : false
                    },
                    {
                        name : 'Rédactrice 11',
                        checked : false
                    },
                    {
                        name : 'Rédactrice 12',
                        checked : false
                    },


                ],
                langues : [
                    {
                        name : 'Français',
                        checked : false
                    },
                    {
                        name : 'Anglais',
                        checked : false
                    },
                    {
                        name : 'Japonais',
                        checked : false
                    },
                    {
                        name : 'Espagnole',
                        checked : false
                    },
                    {
                        name : 'Italien',
                        checked : false
                    },
                    {
                        name : 'Allemand',
                        checked : false
                    },
                    {
                        name : 'Hollandais',
                        checked : false
                    },
                    {
                        name : 'Corréen',
                        checked : false
                    },
                    {
                        name : 'Chinois',
                        checked : false
                    },
                    {
                        name : 'Russe',
                        checked : false
                    },
                    {
                        name : 'Suédois',
                        checked : false
                    },
                    {
                        name : 'Grec',
                        checked : false
                    },


                ],



                classifplace : [
                    {
                        name : 'Art moderne',
                        checked : true
                    },
                    {
                        name : 'Haute époque',
                        checked : true
                    },
                    {
                        name : 'Art moderne',
                        checked : true
                    },
                    {
                        name : 'Haute époque',
                        checked : true
                    },
                    {
                        name : 'Art moderne',
                        checked : false
                    },
                    {
                        name : 'Haute époque',
                        checked : false
                    },


                ]
            }
        ]
    };
    $scope.examples = [
        {
            name: 'Éditorial',
            items: [
                {
                    name: 'LV add'
                },
                {
                    name: 'LV sde'
                },
                {
                    name: 'LV app'
                },
            ]
        },
        {
            name: 'Rubrique',
            items: [
                {
                    name: 'LV test'
                },
                {
                    name: 'LV test'
                },
                {
                    name: 'LV test'
                },
            ]
        },
        {
            name: 'Catégorie',
            items: [
                {
                    name: 'LV test'
                },
                {
                    name: 'LV test'
                },
                {
                    name: 'LV test'
                },
            ]
        },
        {
            name: 'Thématique',
            items: [
                {
                    name: 'LV test'
                },
                {
                    name: 'LV test'
                },
                {
                    name: 'LV test'
                },
            ]
        },
        {
            name: 'Domaine',
            items: [
                {
                    name: 'LV test'
                },
                {
                    name: 'LV test'
                },
                {
                    name: 'LV test'
                },
            ]
        },
        {
            name: 'Dossier &ditorial',
            items: [
                {
                    name: 'LV test'
                },
                {
                    name: 'LV test'
                },
                {
                    name: 'LV test'
                },
            ]
        },
        {
            name: 'Édito',
            items: [
                {
                    name: 'LV test'
                },
                {
                    name: 'LV test'
                },
                {
                    name: 'LV test'
                },
            ]
        },
        {
            name: 'Quartier',
            items: [
                {
                    name: 'LV test'
                },
                {
                    name: 'LV test'
                },
                {
                    name: 'LV test'
                },
            ]
        },
        {
            name: 'Tourisme',
            items: [
                {
                    name: 'LV test'
                },
                {
                    name: 'LV test'
                },
                {
                    name: 'LV test'
                },
            ]
        },
        {
            name: 'Invité',
            items: [
                {
                    name: 'LV test'
                },
                {
                    name: 'LV test'
                },
                {
                    name: 'LV test'
                },
            ]
        },
        {
            name: 'Diffuseur',
            items: [
                {
                    name: 'LV test'
                },
                {
                    name: 'LV test'
                },
                {
                    name: 'LV test'
                },
            ]
        }
    ];

    $scope.examples2 = [
        {
            name: 'Classification',
            items: [
                {
                    name: 'LV add'
                },
                {
                    name: 'LV sde'
                },
                {
                    name: 'LV app'
                },
            ]
        }
    ];

    $scope.prevStateUrl = '#';
    $scope.nextStateUrl = '#';
    $scope.currentState = 0;

    angular.forEach($scope.links, function (value, key) {
        if (value.name == $state.current.name) {
            $scope.currentState = key;
            if (key > 0) {
                $scope.prevStateUrl = $scope.links[key - 1].name != '#' ? $state.href($scope.links[key - 1].name) : '#';
            }
            if (key < $scope.links.length - 1) {
                $scope.nextStateUrl = $scope.links[key + 1].name != '#' ? $state.href($scope.links[key + 1].name) : '#';
            }
        }
    });

    $scope.setCurrentState = function (index) {

        index = (index !== 'undefined') ? index : $scope.currentState;

        $scope.currentState = index;
        $scope.prevStateUrl = $scope.links[index - 1] ? ($scope.links[index - 1].name != '#' ? $state.href($scope.links[index - 1].name) : '#') : '#';
        $scope.nextStateUrl = $scope.links[index + 1] ? ($scope.links[index + 1].name != '#' ? $state.href($scope.links[index + 1].name) : '#') : '#';

        $state.go($scope.links[index].name);

        return false;
    };

    $scope.updateState = function (direction) {
        var index = $scope.currentState;
        switch (direction) {
            case -1:
                if (index > 0) {
                    index = $scope.currentState - 1;
                }
                break;

            case +1:
                if (index < $scope.links.length) {
                    index = $scope.currentState + 1;

                }
                break;
        }
        $scope.setCurrentState(index);
    }

    $scope.$on('elastic:resize', function(event, element, oldHeight, newHeight) {
        switch(element.attr("ng-model")) {
            case 'newClient.sousTitreDesc':
            case 'newItem.description[0].sousTitreDesc':
            case 'subtitleTranslate':
                element.parents('.row').find('.block-lecture .sous-titre.desc').css('height', newHeight);
                break;

            case 'newClient.txtDesc':
            case 'newItem.description[0].txtDesc' :
            case 'contentTranslate':
                element.parents('.row').find('.block-lecture .text-desc').css('height', newHeight);
                break;
        }
    });

    $scope.client = [
        {name : '24h dans la ville',
        sousTitre : 'Douze expériences choisies, subjectives et assumées',
        titreDesc: 'Institution',
        sousTitreDesc: 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non' + ' nulli velariis',
        resumeDesc:'résumé',
        txtDesc: 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non nulli velariis umbraculorum theatralium latent, quae Campanam imitatus lasciviam Catulus in aedilitate sua suspendit omnium primus; aut pugnaciter aleis certant turpi sono fragosis naribus introrsum reducto spiritu concrepantes; aut quod est studiorum omnium maximum ab ortu lucis ad vesperam sole fatiscunt vel pluviis, per minutias aurigarum equorumque praecipua vel delicta scrutantes.',
        clients:[
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked:true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked:true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked:true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked:false
            },
            {
                name: 'LV Print',
                checked: false
            },
            {
                name: 'LV App',
                checked:false
            },
            {
                name: 'LV Print',
                checked: false
            },
            {
                name: 'LV App',
                checked:false
            },
        ],
        classifications: [
            {
                name: 'Art moderne',
                checked: true
            },
            {
                name: 'Haute époque',
                checked: true
            },
            {
                name: 'Art moderne',
                checked: true
            },
            {
                name: 'Haute époque',
                checked: true
            },
            {
                name: 'Art moderne',
                checked: false
            },
            {
                name: 'Haute époque',
                checked: false
            },


        ],
        qualifications : [
            {
                name : 'Qualification 01',
                checked : false
            },
            {
                name : 'Qualification 02',
                checked : false
            },
            {
                name : 'Qualification 03',
                checked : false
            },
            {
                name : 'Qualification 04',
                checked : false
            },
            {
                name : 'Qualification 05',
                checked : false
            },
            {
                name : 'Qualification 06',
                checked : false
            },
            {
                name : 'Qualification 07',
                checked : false
            },
            {
                name : 'Qualification 08',
                checked : false
            },
            {
                name : 'Qualification 09',
                checked : false
            },
            {
                name : 'Qualification 10',
                checked : false
            },
            {
                name : 'Qualification 11',
                checked : false
            },
            {
                name : 'Qualification 12',
                checked : false
            },


        ],
        status : [
            {
                name : 'Statut 01',
                checked : false
            },
            {
                name : 'Statut 02',
                checked : false
            },
            {
                name : 'Statut 03',
                checked : false
            },
            {
                name : 'Statut 04',
                checked : false
            },
            {
                name : 'Statut 05',
                checked : false
            },
            {
                name : 'Statut 06',
                checked : false
            },
            {
                name : 'Statut 07',
                checked : false
            },
            {
                name : 'Statut 08',
                checked : false
            },
            {
                name : 'Statut 09',
                checked : false
            },
            {
                name : 'Statut 10',
                checked : false
            },
            {
                name : 'Statut 11',
                checked : false
            },
            {
                name : 'Statut 12',
                checked : false
            },


        ],
        auteurs : [
            {
                name : 'Auteur 01',
                checked : false
            },
            {
                name : 'Auteur 02',
                checked : false
            },
            {
                name : 'Auteur 03',
                checked : false
            },
            {
                name : 'Auteur 04',
                checked : false
            },
            {
                name : 'Auteur 05',
                checked : false
            },
            {
                name : 'Auteur 06',
                checked : false
            },
            {
                name : 'Auteur 07',
                checked : false
            },
            {
                name : 'Auteur 08',
                checked : false
            },
            {
                name : 'Auteur 09',
                checked : false
            },
            {
                name : 'Auteur 10',
                checked : false
            },
            {
                name : 'Auteur 11',
                checked : false
            },
            {
                name : 'Auteur 12',
                checked : false
            },


        ],
        traducteurs : [
            {
                name : 'Traducteur 01',
                checked : false
            },
            {
                name : 'Traducteur 02',
                checked : false
            },
            {
                name : 'Traducteur 03',
                checked : false
            },
            {
                name : 'Traducteur 04',
                checked : false
            },
            {
                name : 'Traducteur 05',
                checked : false
            },
            {
                name : 'Traducteur 06',
                checked : false
            },
            {
                name : 'Traducteur 07',
                checked : false
            },
            {
                name : 'Traducteur 08',
                checked : false
            },
            {
                name : 'Traducteur 09',
                checked : false
            },
            {
                name : 'Traducteur 10',
                checked : false
            },
            {
                name : 'Traducteur 11',
                checked : false
            },
            {
                name : 'Traducteur 12',
                checked : false
            },


        ],
        correcteurs : [
            {
                name : 'Correcteur 01',
                checked : false
            },
            {
                name : 'Correcteur 02',
                checked : false
            },
            {
                name : 'Correcteur 03',
                checked : false
            },
            {
                name : 'Correcteur 04',
                checked : false
            },
            {
                name : 'Correcteur 05',
                checked : false
            },
            {
                name : 'Correcteur 06',
                checked : false
            },
            {
                name : 'Correcteur 07',
                checked : false
            },
            {
                name : 'Correcteur 08',
                checked : false
            },
            {
                name : 'Correcteur 09',
                checked : false
            },
            {
                name : 'Correcteur 10',
                checked : false
            },
            {
                name : 'Correcteur 11',
                checked : false
            },
            {
                name : 'Correcteur 12',
                checked : false
            },


        ],
        secretairesDeRedaction : [
            {
                name : 'Secretaire de rédaction 01',
                checked : false
            },
            {
                name : 'Secretaire de rédaction 02',
                checked : false
            },
            {
                name : 'Secretaire de rédaction 03',
                checked : false
            },
            {
                name : 'Secretaire de rédaction 04',
                checked : false
            },
            {
                name : 'Secretaire de rédaction 05',
                checked : false
            },
            {
                name : 'Rédactrice 06',
                checked : false
            },
            {
                name : 'Rédactrice 07',
                checked : false
            },
            {
                name : 'Rédactrice 08',
                checked : false
            },
            {
                name : 'Rédactrice 09',
                checked : false
            },
            {
                name : 'Rédactrice 10',
                checked : false
            },
            {
                name : 'Rédactrice 11',
                checked : false
            },
            {
                name : 'Rédactrice 12',
                checked : false
            },


        ],
        langues : [
            {
                name : 'Français',
                checked : false
            },
            {
                name : 'Anglais',
                checked : false
            },
            {
                name : 'Japonais',
                checked : false
            },
            {
                name : 'Espagnole',
                checked : false
            },
            {
                name : 'Italien',
                checked : false
            },
            {
                name : 'Allemand',
                checked : false
            },
            {
                name : 'Hollandais',
                checked : false
            },
            {
                name : 'Corréen',
                checked : false
            },
            {
                name : 'Chinois',
                checked : false
            },
            {
                name : 'Russe',
                checked : false
            },
            {
                name : 'Suédois',
                checked : false
            },
            {
                name : 'Grec',
                checked : false
            },


        ],
        diffuseurs:[
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked:true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked:true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked:true
            },
            {
                name: 'LV Print',
                checked: true
            },
            {
                name: 'LV App',
                checked:false
            },
            {
                name: 'LV Print',
                checked: false
            },
            {
                name: 'LV App',
                checked:false
            },
            {
                name: 'LV Print',
                checked: false
            },
            {
                name: 'LV App',
                checked:false
            },
        ],
        data : '[Client1] [Client2]',
        qualification : '[Qualifications]'},
        {name : '24h dans la ville',
            sousTitre : 'Douze expériences choisies, subjectives et assumées',
            titreDesc: ' Beaux-Arts ',
            sousTitreDesc: 'tus lasciviam Catulus in aedilitate sua suspendit omnium primus; aut pugnaciter ale',
            resumeDesc:'résumé',
            txtDesc: 'Ex  theatralium latent, quae Campanam imitatus lasciviam Catulus in aedilitate sua suspendit omnium primus; aut pugnaciter aleis certant turpi sono fragosis naribus introrsum reducto spiritu concrepantes; aut quod est studiorum omnium maximum ab ortu lucis ad vesperam sole fatiscunt vel pluviis, per minutias aurigarum equorumque praecipua vel delicta scrutantes.',
            clients:[
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked:true
                },
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked:true
                },
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked:true
                },
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked:false
                },
                {
                    name: 'LV Print',
                    checked: false
                },
                {
                    name: 'LV App',
                    checked:false
                },
                {
                    name: 'LV Print',
                    checked: false
                },
                {
                    name: 'LV App',
                    checked:false
                },
            ],
            classifications: [
                {
                    name: 'Art moderne',
                    checked: true
                },
                {
                    name: 'Haute époque',
                    checked: true
                },
                {
                    name: 'Art moderne',
                    checked: true
                },
                {
                    name: 'Haute époque',
                    checked: true
                },
                {
                    name: 'Art moderne',
                    checked: false
                },
                {
                    name: 'Haute époque',
                    checked: false
                },


            ],
            qualifications : [
                {
                    name : 'Qualification 01',
                    checked : false
                },
                {
                    name : 'Qualification 02',
                    checked : false
                },
                {
                    name : 'Qualification 03',
                    checked : false
                },
                {
                    name : 'Qualification 04',
                    checked : false
                },
                {
                    name : 'Qualification 05',
                    checked : false
                },
                {
                    name : 'Qualification 06',
                    checked : false
                },
                {
                    name : 'Qualification 07',
                    checked : false
                },
                {
                    name : 'Qualification 08',
                    checked : false
                },
                {
                    name : 'Qualification 09',
                    checked : false
                },
                {
                    name : 'Qualification 10',
                    checked : false
                },
                {
                    name : 'Qualification 11',
                    checked : false
                },
                {
                    name : 'Qualification 12',
                    checked : false
                },


            ],
            status : [
                {
                    name : 'Statut 01',
                    checked : false
                },
                {
                    name : 'Statut 02',
                    checked : false
                },
                {
                    name : 'Statut 03',
                    checked : false
                },
                {
                    name : 'Statut 04',
                    checked : false
                },
                {
                    name : 'Statut 05',
                    checked : false
                },
                {
                    name : 'Statut 06',
                    checked : false
                },
                {
                    name : 'Statut 07',
                    checked : false
                },
                {
                    name : 'Statut 08',
                    checked : false
                },
                {
                    name : 'Statut 09',
                    checked : false
                },
                {
                    name : 'Statut 10',
                    checked : false
                },
                {
                    name : 'Statut 11',
                    checked : false
                },
                {
                    name : 'Statut 12',
                    checked : false
                },


            ],
            auteurs : [
                {
                    name : 'Auteur 01',
                    checked : false
                },
                {
                    name : 'Auteur 02',
                    checked : false
                },
                {
                    name : 'Auteur 03',
                    checked : false
                },
                {
                    name : 'Auteur 04',
                    checked : false
                },
                {
                    name : 'Auteur 05',
                    checked : false
                },
                {
                    name : 'Auteur 06',
                    checked : false
                },
                {
                    name : 'Auteur 07',
                    checked : false
                },
                {
                    name : 'Auteur 08',
                    checked : false
                },
                {
                    name : 'Auteur 09',
                    checked : false
                },
                {
                    name : 'Auteur 10',
                    checked : false
                },
                {
                    name : 'Auteur 11',
                    checked : false
                },
                {
                    name : 'Auteur 12',
                    checked : false
                },


            ],
            traducteurs : [
                {
                    name : 'Traducteur 01',
                    checked : false
                },
                {
                    name : 'Traducteur 02',
                    checked : false
                },
                {
                    name : 'Traducteur 03',
                    checked : false
                },
                {
                    name : 'Traducteur 04',
                    checked : false
                },
                {
                    name : 'Traducteur 05',
                    checked : false
                },
                {
                    name : 'Traducteur 06',
                    checked : false
                },
                {
                    name : 'Traducteur 07',
                    checked : false
                },
                {
                    name : 'Traducteur 08',
                    checked : false
                },
                {
                    name : 'Traducteur 09',
                    checked : false
                },
                {
                    name : 'Traducteur 10',
                    checked : false
                },
                {
                    name : 'Traducteur 11',
                    checked : false
                },
                {
                    name : 'Traducteur 12',
                    checked : false
                },


            ],
            correcteurs : [
                {
                    name : 'Correcteur 01',
                    checked : false
                },
                {
                    name : 'Correcteur 02',
                    checked : false
                },
                {
                    name : 'Correcteur 03',
                    checked : false
                },
                {
                    name : 'Correcteur 04',
                    checked : false
                },
                {
                    name : 'Correcteur 05',
                    checked : false
                },
                {
                    name : 'Correcteur 06',
                    checked : false
                },
                {
                    name : 'Correcteur 07',
                    checked : false
                },
                {
                    name : 'Correcteur 08',
                    checked : false
                },
                {
                    name : 'Correcteur 09',
                    checked : false
                },
                {
                    name : 'Correcteur 10',
                    checked : false
                },
                {
                    name : 'Correcteur 11',
                    checked : false
                },
                {
                    name : 'Correcteur 12',
                    checked : false
                },


            ],
            secretairesDeRedaction : [
                {
                    name : 'Secretaire de rédaction 01',
                    checked : false
                },
                {
                    name : 'Secretaire de rédaction 02',
                    checked : false
                },
                {
                    name : 'Secretaire de rédaction 03',
                    checked : false
                },
                {
                    name : 'Secretaire de rédaction 04',
                    checked : false
                },
                {
                    name : 'Secretaire de rédaction 05',
                    checked : false
                },
                {
                    name : 'Rédactrice 06',
                    checked : false
                },
                {
                    name : 'Rédactrice 07',
                    checked : false
                },
                {
                    name : 'Rédactrice 08',
                    checked : false
                },
                {
                    name : 'Rédactrice 09',
                    checked : false
                },
                {
                    name : 'Rédactrice 10',
                    checked : false
                },
                {
                    name : 'Rédactrice 11',
                    checked : false
                },
                {
                    name : 'Rédactrice 12',
                    checked : false
                },


            ],
            langues : [
                {
                    name : 'Français',
                    checked : false
                },
                {
                    name : 'Anglais',
                    checked : false
                },
                {
                    name : 'Japonais',
                    checked : false
                },
                {
                    name : 'Espagnole',
                    checked : false
                },
                {
                    name : 'Italien',
                    checked : false
                },
                {
                    name : 'Allemand',
                    checked : false
                },
                {
                    name : 'Hollandais',
                    checked : false
                },
                {
                    name : 'Corréen',
                    checked : false
                },
                {
                    name : 'Chinois',
                    checked : false
                },
                {
                    name : 'Russe',
                    checked : false
                },
                {
                    name : 'Suédois',
                    checked : false
                },
                {
                    name : 'Grec',
                    checked : false
                },


            ],
            diffuseurs:[
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked:true
                },
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked:true
                },
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked:true
                },
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked:false
                },
                {
                    name: 'LV Print',
                    checked: false
                },
                {
                    name: 'LV App',
                    checked:false
                },
                {
                    name: 'LV Print',
                    checked: false
                },
                {
                    name: 'LV App',
                    checked:false
                },
            ],
            data : '[Client1] [Client2]',
            qualification : '[Qualifications]'}

    ];

    $scope.sort = {
        column: 'position',
        descending: false
    };

    $scope.selectedCls = function (column) {
        return column == $scope.sort.column && 'sort-' + $scope.sort.descending;
    };

    $scope.changePosition = function () {
        var sort = $scope.sort;
    };

    $scope.$on('orderUp', function(event, data) {
        var dataTable = $scope.walks;
        var index = 0;

        for (var i in dataTable) {
          if(dataTable[i].title == data.element.parents('tr').find('td').html().trim()) {
              index = i;
          }
        }

        var currentPosition = dataTable[index].position;

        if (currentPosition > 1) {
          for (var i in dataTable) {
            if(dataTable[i].position == currentPosition-1) {
              dataTable[i].position = currentPosition;
            }
          }
          dataTable[index].position = (currentPosition-1) + "";
        }
    });

    $scope.$on('orderDown', function(event, data) {
        var dataTable = $scope.walks;
        var index = 0;

        for (var i in dataTable) {
          if(dataTable[i].title == data.element.parents('tr').find('td').html().trim()) {
              index = i;
          }
        }

        var currentPosition = dataTable[index].position;

        if (currentPosition < dataTable.length) {
          for (var i in dataTable) {
            if(dataTable[i].position == parseInt(currentPosition)+1) {
              dataTable[i].position = currentPosition;
            }
          }
          dataTable[index].position = (parseInt(currentPosition)+1) + "";
        }
    });

    $scope.indice = 0;

    $scope.nextDesc = function () {
        if ( $scope.indice < $scope.client.length - 1  )
        {
            $scope.indice ++;
        }
    };

    $scope.prevDesc = function () {
        if ( $scope.indice > 0 )
        {
            $scope.indice --;
        }
    };
    $scope.newDescriptif = false;

    $scope.addDesc = function () {
        $scope.client.unshift ({
            name: '24h dans la ville',
            sousTitre: 'Douze expériences choisies, subjectives et assumées',
            titreDesc: '',
            sousTitreDesc: '',
            resumeDesc: '',
            txtDesc: '',
            clients: [
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked: true
                },
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked: true
                },
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked: true
                },
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked: false
                },
                {
                    name: 'LV Print',
                    checked: false
                },
                {
                    name: 'LV App',
                    checked: false
                },
                {
                    name: 'LV Print',
                    checked: false
                },
                {
                    name: 'LV App',
                    checked: false
                },
            ],
            classifications: [
                {
                    name: 'Art moderne',
                    checked: true
                },
                {
                    name: 'Haute époque',
                    checked: true
                },
                {
                    name: 'Art moderne',
                    checked: true
                },
                {
                    name: 'Haute époque',
                    checked: true
                },
                {
                    name: 'Art moderne',
                    checked: false
                },
                {
                    name: 'Haute époque',
                    checked: false
                },


            ],
            qualifications: [
                {
                    name: 'Qualification 01',
                    checked: false
                },
                {
                    name: 'Qualification 02',
                    checked: false
                },
                {
                    name: 'Qualification 03',
                    checked: false
                },
                {
                    name: 'Qualification 04',
                    checked: false
                },
                {
                    name: 'Qualification 05',
                    checked: false
                },
                {
                    name: 'Qualification 06',
                    checked: false
                },
                {
                    name: 'Qualification 07',
                    checked: false
                },
                {
                    name: 'Qualification 08',
                    checked: false
                },
                {
                    name: 'Qualification 09',
                    checked: false
                },
                {
                    name: 'Qualification 10',
                    checked: false
                },
                {
                    name: 'Qualification 11',
                    checked: false
                },
                {
                    name: 'Qualification 12',
                    checked: false
                },


            ],
            status: [
                {
                    name: 'Statut 01',
                    checked: false
                },
                {
                    name: 'Statut 02',
                    checked: false
                },
                {
                    name: 'Statut 03',
                    checked: false
                },
                {
                    name: 'Statut 04',
                    checked: false
                },
                {
                    name: 'Statut 05',
                    checked: false
                },
                {
                    name: 'Statut 06',
                    checked: false
                },
                {
                    name: 'Statut 07',
                    checked: false
                },
                {
                    name: 'Statut 08',
                    checked: false
                },
                {
                    name: 'Statut 09',
                    checked: false
                },
                {
                    name: 'Statut 10',
                    checked: false
                },
                {
                    name: 'Statut 11',
                    checked: false
                },
                {
                    name: 'Statut 12',
                    checked: false
                },


            ],
            auteurs: [
                {
                    name: 'Auteur 01',
                    checked: false
                },
                {
                    name: 'Auteur 02',
                    checked: false
                },
                {
                    name: 'Auteur 03',
                    checked: false
                },
                {
                    name: 'Auteur 04',
                    checked: false
                },
                {
                    name: 'Auteur 05',
                    checked: false
                },
                {
                    name: 'Auteur 06',
                    checked: false
                },
                {
                    name: 'Auteur 07',
                    checked: false
                },
                {
                    name: 'Auteur 08',
                    checked: false
                },
                {
                    name: 'Auteur 09',
                    checked: false
                },
                {
                    name: 'Auteur 10',
                    checked: false
                },
                {
                    name: 'Auteur 11',
                    checked: false
                },
                {
                    name: 'Auteur 12',
                    checked: false
                },


            ],
            traducteurs: [
                {
                    name: 'Traducteur 01',
                    checked: false
                },
                {
                    name: 'Traducteur 02',
                    checked: false
                },
                {
                    name: 'Traducteur 03',
                    checked: false
                },
                {
                    name: 'Traducteur 04',
                    checked: false
                },
                {
                    name: 'Traducteur 05',
                    checked: false
                },
                {
                    name: 'Traducteur 06',
                    checked: false
                },
                {
                    name: 'Traducteur 07',
                    checked: false
                },
                {
                    name: 'Traducteur 08',
                    checked: false
                },
                {
                    name: 'Traducteur 09',
                    checked: false
                },
                {
                    name: 'Traducteur 10',
                    checked: false
                },
                {
                    name: 'Traducteur 11',
                    checked: false
                },
                {
                    name: 'Traducteur 12',
                    checked: false
                },


            ],
            correcteurs: [
                {
                    name: 'Correcteur 01',
                    checked: false
                },
                {
                    name: 'Correcteur 02',
                    checked: false
                },
                {
                    name: 'Correcteur 03',
                    checked: false
                },
                {
                    name: 'Correcteur 04',
                    checked: false
                },
                {
                    name: 'Correcteur 05',
                    checked: false
                },
                {
                    name: 'Correcteur 06',
                    checked: false
                },
                {
                    name: 'Correcteur 07',
                    checked: false
                },
                {
                    name: 'Correcteur 08',
                    checked: false
                },
                {
                    name: 'Correcteur 09',
                    checked: false
                },
                {
                    name: 'Correcteur 10',
                    checked: false
                },
                {
                    name: 'Correcteur 11',
                    checked: false
                },
                {
                    name: 'Correcteur 12',
                    checked: false
                },


            ],
            secretairesDeRedaction: [
                {
                    name: 'Secretaire de rédaction 01',
                    checked: false
                },
                {
                    name: 'Secretaire de rédaction 02',
                    checked: false
                },
                {
                    name: 'Secretaire de rédaction 03',
                    checked: false
                },
                {
                    name: 'Secretaire de rédaction 04',
                    checked: false
                },
                {
                    name: 'Secretaire de rédaction 05',
                    checked: false
                },
                {
                    name: 'Rédactrice 06',
                    checked: false
                },
                {
                    name: 'Rédactrice 07',
                    checked: false
                },
                {
                    name: 'Rédactrice 08',
                    checked: false
                },
                {
                    name: 'Rédactrice 09',
                    checked: false
                },
                {
                    name: 'Rédactrice 10',
                    checked: false
                },
                {
                    name: 'Rédactrice 11',
                    checked: false
                },
                {
                    name: 'Rédactrice 12',
                    checked: false
                },


            ],
            langues: [
                {
                    name: 'Français',
                    checked: false
                },
                {
                    name: 'Anglais',
                    checked: false
                },
                {
                    name: 'Japonais',
                    checked: false
                },
                {
                    name: 'Espagnole',
                    checked: false
                },
                {
                    name: 'Italien',
                    checked: false
                },
                {
                    name: 'Allemand',
                    checked: false
                },
                {
                    name: 'Hollandais',
                    checked: false
                },
                {
                    name: 'Corréen',
                    checked: false
                },
                {
                    name: 'Chinois',
                    checked: false
                },
                {
                    name: 'Russe',
                    checked: false
                },
                {
                    name: 'Suédois',
                    checked: false
                },
                {
                    name: 'Grec',
                    checked: false
                },


            ],
            diffuseurs: [
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked: true
                },
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked: true
                },
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked: true
                },
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked: false
                },
                {
                    name: 'LV Print',
                    checked: false
                },
                {
                    name: 'LV App',
                    checked: false
                },
                {
                    name: 'LV Print',
                    checked: false
                },
                {
                    name: 'LV App',
                    checked: false
                },
            ],
            data : '',
            qualification : ''
        });
        $scope.newDescriptif = true;
    };

    $scope.activeDescriptif = function () {
        $scope.newDescriptif = false;
    };

}